<template>
  <div class="logisticsStatus">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.logisticsStatus.serialNumber }}：{{ item.SortNum }}
        </div>
        <div class="list-item">
          {{ $t.logisticsStatus.logisticsCn }}：{{ item.StateName }}
        </div>
        <div class="list-item">
          {{ $t.logisticsStatus.logisticsEn }}：{{ item.StateNameEn }}
        </div>
        <div class="list-item">
          {{ $t.logisticsStatus.logisticsSn }}：{{ item.StateNameSn }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow('edit', item)"
            >{{ $t.meta.edit }}</van-button
          >
          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="deleteLogisticsState(item.Id)"
            >{{ $t.meta.delete }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-dialog
      :title="
        dialogType == 'edit' ? $t.logisticsStatus.editState : $t.logisticsStatus.addState
      "
      width="90%"
      v-model="dialogVisible"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <van-form label-width="120px" style="margin: 10px">
        <van-field
          v-model="dialogForm.StateName"
          :label="$t.logisticsStatus.stateCn"
          :placeholder="$t.meta.input"
          type="textarea"
          rows="3"
        />
        <van-field
          v-model="dialogForm.StateNameEn"
          :label="$t.logisticsStatus.stateEn"
          :placeholder="$t.meta.input"
          type="textarea"
          rows="3"
        />
        <van-field
          v-model="dialogForm.StateNameSn"
          :label="$t.logisticsStatus.logisticsSn"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="dialogForm.SortNum"
          :label="$t.logisticsStatus.sortNumber"
          :placeholder="$t.meta.input"
        />
      </van-form>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="dialogShow('add', null)">{{
        $t.logisticsStatus.add
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Row, Col, Search, Button, Form, Field } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Search).use(Button).use(Form).use(Field);

export default {
  name: "logisticsStatus",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      searchText: "",
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //弹窗
      dialogType: "add",
      dialogVisible: false,
      dialogForm: {
        StateId: null,
        StateName: "",
        StateNameEn: "",
        StateNameSn: "",
        SortNum: "",
      },
    };
  },
  created() {},
  methods: {
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    dialogConfirm() {
      this.$commonMethod.showLoading();
      var param = this.dialogForm;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.dialogType == "edit") {
        request = this.$api.logisticsManagement.editLogisticsState(param);
      } else {
        request = this.$api.logisticsManagement.addLogisticsState(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.dialogVisible = false;
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogCancel() {
      this.dialogVisible = false;
    },
    dialogShow(type, row) {
      this.dialogType = type;
      if (type == "edit") {
        this.dialogForm.StateId = row.Id;
        this.dialogForm.StateName = row.StateName;
        this.dialogForm.StateNameEn = row.StateNameEn;
        this.dialogForm.StateNameSn = row.StateNameSn;
        this.dialogForm.SortNum = row.SortNum;
      } else {
        this.dialogForm.StateId = null;
        this.dialogForm.StateName = "";
        this.dialogForm.StateNameEn = "";
        this.dialogForm.StateNameSn = "";
        this.dialogForm.SortNum = "";
      }
      this.dialogVisible = true;
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        StateName: this.searchText,
      };
      this.$api.logisticsManagement
        .getLogisticsStateList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    deleteLogisticsState(id) {
      this.$commonMethod.showLoading();
      var param = {
        StateIds: id,
      };
      this.$api.logisticsManagement
        .deleteLogisticsState(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.logisticsStatus {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
        }
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 14px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
